import * as React from "react";
import { Link } from "gatsby";
import { get } from "lodash";
import { Table, Header, Container, Segment, Icon, Label, Image, List } from "semantic-ui-react";
import { ContentfulCourse } from "../graphql-types";
import BlogTitle from "../components/BlogTitle";
import { DiscussionEmbed } from "disqus-react";
import {withLayout, LayoutProps} from "../components/Layout";
import { graphql } from "gatsby";
import * as assert from "assert";
import Truncate from 'react-truncate';

interface CourseResourcePageProps extends LayoutProps {
  data: {
    course: ContentfulCourse;
  };
}



const CourseResourcePage = (props: CourseResourcePageProps) => {
  const { courseName, courseNumber, semester, syllabus } = props.data.course;
  const resources = props.data.course.resources.contentSections;
  const weeklyContent = props.data.course.weeklyContent;
  const weeks = (!weeklyContent) ? null : props.data.course.weeklyContent.weeks;
  
  const weeklyContentTable = (!weeklyContent) ? null :     
    <Table celled striped unstackable>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Week of</Table.HeaderCell>
        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map(day => {
          if (weeklyContent[day.toLowerCase()]) return <Table.HeaderCell>{day}</Table.HeaderCell>
        })}
        <Table.HeaderCell>Due</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
        {weeks.map(week => 
        <Table.Row>
          <Table.Cell> {week.weekOf} </Table.Cell>
          {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map(day => {
          if (weeklyContent[day.toLowerCase()]) {
            const dayinfo = week[day.toLowerCase()];
            const daytext = week[day.toLowerCase()+"Text"];
            return <Table.Cell>{
              (!dayinfo && !daytext) ? "" : 
              <List>
              {(!daytext) ? "" : <List.Item>{daytext}</List.Item>}
              {(!dayinfo) ? "" : dayinfo.map(myfile => <List.Item>
                <a href={`https:${myfile.file.url}`}><Truncate width={120}>{myfile.description}</Truncate></a>
            </List.Item>)}
            </List>}
          </Table.Cell>;
        }})}
    
           <Table.Cell> 
            {!week.due && !week.dueText ? "" :
              <List>
              {(!week.dueText) ? "" : <List.Item>{week.dueText}</List.Item>}
              {(!week.due) ? "" : week.due.map(myfile => <List.Item><a href={`https:${myfile.file.url}`}><Truncate width={120}>{myfile.description}</Truncate></a></List.Item>)} 
            </List>}
           </Table.Cell>
        </Table.Row>)}
    </Table.Body>
    </Table>;
  
  
  return <Container text>
      <Header as="h1">
        {courseNumber}: {courseName} Resources
        <Header.Subheader>{semester}</Header.Subheader>
      </Header>
      {weeklyContentTable}
      {resources && resources.map((resource) => {
        switch (resource.__typename) {
          case "ContentfulFileBlock":
          const header = <Header>{resource.displayName}</Header>;
          const files = resource.files;
            const links = files.map((file) => {
              return <div><a href={file.file.url}>{file.description}</a></div>;
            });
            return [header, links];
            break;
          case "ContentfulResourceBlock":
            const headerr = <Header>{resource.name}</Header>;
            const body = resource.resourceContent.childContentfulRichText.html;
            const div = <div dangerouslySetInnerHTML={{__html: body}} />;
            return [headerr, div];
            break;
          default:
            assert(false);
        }
      })}
    </Container>;
};

export default withLayout(CourseResourcePage);

export const pageQuery = graphql`
  query TemplateCourseResourcePage($slug: String!) {
  course: contentfulCourse(fields: {slug: {eq: $slug}}) {
    resources {
			contentSections {
        __typename
        ... on ContentfulFileBlock {
          displayName
          files {
            description
            file {
              fileName
              url
              details {
                size
              }
            }
          }
        }
        ... on ContentfulResourceBlock {
          name
          resourceContent {
            childContentfulRichText {
              html
            }
          }
        }
      }
    }
    weeklyContent 
    {
      monday
      tuesday
      wednesday
      thursday
      friday
      weeks {
        weekOf
        monday {
          file {
            url
          }
          description
        }
        tuesday {
          file {
            
            url
          }
          description
        }
        wednesday {
          file {
            
            url
          }
          description
        }
        thursday {
          file {
            
            url
          }
          description
        }
        friday {
          file {
            url
          }
          description
        }
        due {
          file {
            url
          }
          title
          description
        }
        mondayText
        tuesdayText
        wednesdayText
        thursdayText
        fridayText
        dueText
      } 
    }  
    courseName
    courseNumber
    semester
    fields {
      slug
    }
  }
}
`;
